import { List, Text } from '@foradevelopment/fora-ui';

// 172050
export const FileReportTempTier1ErrorMessage = () => (
  <>
    <Text size="small" marginTop={10}>
      Det gick inte att skicka in den här rapporten. Det kan exempelvis bero på något av följande:
    </Text>
    <List bullet="dot" itemSpacing={0} fontSize="small">
      <List.Item>
        <List.Description>lön har hänförts till den månad lönen är utbetald</List.Description>
      </List.Item>
      <List.Item>
        <List.Description>lön har hänförts till en framtida månad</List.Description>
      </List.Item>
      <List.Item>
        <List.Description>lön har hänförts två eller fler gånger till en och samma månad.</List.Description>
      </List.Item>
    </List>
    <Text size="small">
      Korrigera detta i lönesystemet, kontrollera också att inga individer under 13 och över 99 år finns med. Ta sedan
      ut en ny fil och ladda upp.
    </Text>
  </>
);
